import PublicationShipmentAppService from "../../../../application/platform/publication-shipment/publication-shipment-app-service";
import { ACTION_TYPES, useEnvioRemessaDispatch, useEnvioRemessaState } from "./envio-remessa-context";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import dayjs, { Dayjs } from "dayjs";
import { title } from "process";
import { IAddPublicationShipmentRequest } from "../../../../model/publication-shipment/request/add-publication-shipment-request";

export const useEnvioRemessaController = () => {
    const { showMessage, showBackDrop } = useBaseLayoutController();
    const envioRemessaDispatch = useEnvioRemessaDispatch();
    const envioRemessaState = useEnvioRemessaState();
    const { addPublicationShipmentRequest, files } = useEnvioRemessaState();
   
    const getInit = async () => {
        showBackDrop(true);
        var response = await PublicationShipmentAppService.listPublishingVehicle();
        envioRemessaDispatch({
            type: ACTION_TYPES.setListPublishingVehicleResponse,
            payload: response,
        });

        envioRemessaDispatch({
            type: ACTION_TYPES.setAddPublicationShipmentRequest,
            payload: { publishIn: dayjs().format("YYYY-MM-DD"), type: 1, publicationVehicles: [] as number[], title: "", description: "", observation: "" } as IAddPublicationShipmentRequest,
        });

        envioRemessaDispatch({
            type: ACTION_TYPES.setFiles,
            payload: [] as File[],
        });

        showBackDrop(false);
    }
    const sendPublicationShipment = async () => {
        if (validFields()) {
            if (files === undefined || files.length === 0) {
                showMessage({ type: 'error', message: 'É necessário selecionar ao menos um arquivo para enivar a remessa.' });
                return;
            }

            showBackDrop(true);
            await PublicationShipmentAppService.addPublicationShipmentRequest(addPublicationShipmentRequest, files);
            showMessage({ type: 'success', message: 'Remessa enviada com sucesso para publição.' });
            getInit();
            showBackDrop(false);
        } else {
            showMessage({ type: 'error', message: 'É necessário preencher todos os campos obrigtórios.' });

        }
    }
    function handleOnChange(e: any) {

        let type = addPublicationShipmentRequest?.type;

        let description = addPublicationShipmentRequest?.description;
        let observation = addPublicationShipmentRequest?.observation;
        let publicationVehicles = addPublicationShipmentRequest?.publicationVehicles;
        let title = addPublicationShipmentRequest?.title;

        if (e.target.name === "select-type") {
            type = e.target.value;
        }else   if (e.target.name === "input-description") {
            description = e.target.value;
        } else if (e.target.name === "input-observation") {
            observation = e.target.value;
        } else if (e.target.name === "input-title") {
            title = e.target.value;
        } else if (e.target.name === "check-vehicle-publication") {
            if (e.target.checked) {
                publicationVehicles = [...publicationVehicles, parseInt(e.target.value)];
            } else {
                publicationVehicles = publicationVehicles.filter((item) => item !== parseInt(e.target.value));

            }
        }
        envioRemessaDispatch({
            type: ACTION_TYPES.setAddPublicationShipmentRequest,
            payload: { ...addPublicationShipmentRequest, type, description: description?.toUpperCase(), observation: observation?.toUpperCase(), title, publicationVehicles },
        });
    };
    const setFiles = (files: File[]) => {
        envioRemessaDispatch({
            type: ACTION_TYPES.setFiles,
            payload: files,
        });
    }
    function validFields() {
        let isValid = true;
        if (envioRemessaState.addPublicationShipmentRequest?.type === undefined || envioRemessaState.addPublicationShipmentRequest?.type === 0) {
            isValid = false;
        }

        if (envioRemessaState.addPublicationShipmentRequest?.publishIn === undefined || envioRemessaState.addPublicationShipmentRequest?.publishIn.length === 0) {
            isValid = false;
        }
        if (envioRemessaState.addPublicationShipmentRequest?.description === undefined || envioRemessaState.addPublicationShipmentRequest?.description.length === 0) {
            isValid = false;
        }
        if (envioRemessaState.addPublicationShipmentRequest?.title === undefined || envioRemessaState.addPublicationShipmentRequest?.title.length === 0) {
            isValid = false;
        }
        if (envioRemessaState.addPublicationShipmentRequest?.publicationVehicles === undefined || envioRemessaState.addPublicationShipmentRequest?.publicationVehicles.length === 0) {
            isValid = false;
        }

        envioRemessaDispatch({
            type: ACTION_TYPES.setFieldIsValid,
            payload: isValid,
        });

        return isValid;
    }
    return {
        sendPublicationShipment, setFiles, validFields, getInit, handleOnChange
    };
}